import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';
import { applicationService } from '@/services/applications';
import { chatService } from '@/services/chat';

export function useAccountAppMixins() {
    const routerLink = {
        detail: (accountId: number) => ({
            name: ROUTE_NAME_ACCOUNT.APP.DETAIL,
            params: { accountId }
        }),
        transaction: (type: TransactionType, accountId: number) => ({
            name: ROUTE_NAME_ACCOUNT.APP.TRANSACTION,
            query: { type },
            params: { accountId }
        }),
        activity: (type: number, criteria: string | number) => ({
            name: ROUTE_NAME_ACCOUNT.APP.ACTIVITY,
            query: { type, criteria }
        })
    };

    return { routerLink };
}

export function useAccountActions(onSuccess?: () => void | Promise<void>) {
    const { confirmAndExecute } = useCrudActions();

    return {
        delete: confirmAndExecute({
            confirmMessage: 'Are you sure you want to delete this account?',
            request: applicationService.account.delete,
            onSuccess
        }),
        undelete: confirmAndExecute({
            confirmMessage: 'Are you sure you want to undelete this account?',
            request: applicationService.account.undelete,
            onSuccess
        }),
        ban: confirmAndExecute({
            confirmMessage: 'Are you sure you want to ban this account?',
            request: applicationService.account.ban,
            onSuccess
        }),
        unban: confirmAndExecute({
            confirmMessage: 'Are you sure you want to unban this account?',
            request: applicationService.account.unban,
            onSuccess
        }),
        mute: confirmAndExecute({
            confirmMessage: 'Are you sure you want to mute this account?',
            request: chatService.account.mute,
            onSuccess
        }),
        unmute: confirmAndExecute({
            confirmMessage: 'Are you sure you want to unmute this account?',
            request: chatService.account.unmute,
            onSuccess
        }),
        banChat: confirmAndExecute({
            confirmMessage: 'Are you sure you want to ban this account from chat?',
            request: chatService.account.ban,
            onSuccess
        }),
        unbanChat: confirmAndExecute({
            confirmMessage: 'Are you sure you want to unban this account from chat?',
            request: chatService.account.unban,
            onSuccess
        })
    };
}

export enum TransactionType {
    Credit = 0,
    Payment = 1,
    Ruby = 2
}

export const ActivityFilterType = {
    AccountId: { value: 0, label: 'Account Id' },
    IpAddress: { value: 1, label: 'Ip Address' },
    DeviceId: { value: 2, label: 'Device Id' }
};

export const AccountFilterType = {
    All: { value: 0, label: 'No filter' },
    Name: { value: 1, label: 'Name' },
    Email: { value: 2, label: 'Email' },
    FacebookID: { value: 3, label: 'Facebook Id' },
    AccountID: { value: 4, label: 'Account Id' },
    CreditBuy: { value: 5, label: 'Bought credit' }
};

export const AccountAppStore = {
    Apple: { value: 0, label: 'Apple' },
    Google: { value: 1, label: 'Google' },
    Facebook: { value: 3, label: 'Facebook' },
    Website: { value: 4, label: 'Website' }
};

export const AccountAppStatus = {
    None: { value: 0, label: '', background: 'success' },
    Banned: { value: 1, label: 'Banned', background: 'warning' },
    BanChat: { value: 2, label: 'Banned-chat', background: 'warning' },
    Mute: { value: 3, label: 'Muted', background: 'warning' },
    Deleting: { value: 4, label: 'Deleting', background: 'danger' }
};

export const AccountAppOptions = {
    ActivityFilterType: Object.entries(ActivityFilterType).map(([, data]) => data),
    AccountFilterType: Object.entries(AccountFilterType).map(([, data]) => data),
    Store: Object.entries(AccountAppStore).map(([, data]) => data),
    Status: Object.entries(AccountAppStatus).map(([, data]) => data)
};
